export const myAccountConstant = {
    GET_ORDER_DETAILS_REQUEST: 'GET_ORDER_DETAILS_REQUEST',
    GET_ORDER_DETAILS_SUCCESS: 'GET_ORDER_DETAILS_SUCCESS',
    GET_ORDER_DETAILS_NODATA: 'GET_ORDER_DETAILS_NODATA',
    GET_ORDER_DETAILS_FAILURE: 'GET_ORDER_DETAILS_FAILURE',

};

